import {defineMessages} from 'react-intl';

export const phoneMessages = defineMessages({
    toLine: {id: 'callSurface.phone.to-line', defaultMessage: 'To {line}'},
    recording: {id: 'callSurface.phone.recording', defaultMessage: 'Recording'},
    likelySpam: {id: 'callSurface.phone.likely-spam', defaultMessage: 'Likely spam'},
    incomingCall: {id: 'callSurface.phone.incoming', defaultMessage: 'Incoming call'},
    incomingCountry: {id: 'callSurface.phone.incoming-country', defaultMessage: 'Incoming call · {country}'},
    incomingRegion: {id: 'callSurface.phone.incoming-region', defaultMessage: 'Incoming call from {name}'},
    callRegion: {id: 'callSurface.phone.region', defaultMessage: 'Phone call with {name}'},
    callRegionRecording: {id: 'callSurface.phone.region-recording', defaultMessage: 'Phone call with {name}, recording on'},
    calling: {id: 'callSurface.phone.calling', defaultMessage: 'Calling…'},
    connecting: {id: 'callSurface.phone.connecting', defaultMessage: 'Connecting…'},
    accept: {id: 'callSurface.phone.accept', defaultMessage: 'Accept'},
    acceptAria: {id: 'callSurface.phone.accept-aria', defaultMessage: 'Accept call from {name}'},
    decline: {id: 'callSurface.phone.decline', defaultMessage: 'Decline'},
    cancel: {id: 'callSurface.phone.cancel', defaultMessage: 'Cancel'},
    endCall: {id: 'callSurface.phone.end', defaultMessage: 'End call'},
    onHold: {id: 'callSurface.phone.on-hold', defaultMessage: 'On hold · {timer}'},
    menuChoice: {id: 'callSurface.phone.menu-choice', defaultMessage: 'Menu choice: {key}'},
    microphoneOff: {id: 'callSurface.phone.microphone-off', defaultMessage: 'Microphone off'},
    detailsTitle: {id: 'callSurface.phone.details-title', defaultMessage: 'Call details'},
    detailsTab: {id: 'callSurface.phone.details-tab', defaultMessage: 'Details'},
    historyTab: {id: 'callSurface.phone.history-tab', defaultMessage: 'History'},
    rowLine: {id: 'callSurface.phone.row-line', defaultMessage: 'Line'},
    rowNumber: {id: 'callSurface.phone.row-number', defaultMessage: 'Number'},
    rowStarted: {id: 'callSurface.phone.row-started', defaultMessage: 'Started'},
    rowRecording: {id: 'callSurface.phone.row-recording', defaultMessage: 'Recording'},
    on: {id: 'callSurface.phone.on', defaultMessage: 'On'},
    off: {id: 'callSurface.phone.off', defaultMessage: 'Off'},
    historyEmpty: {id: 'callSurface.phone.history-empty', defaultMessage: 'No earlier calls with this number.'},
    historyIncoming: {id: 'callSurface.phone.history-incoming', defaultMessage: 'Incoming'},
    historyOutgoing: {id: 'callSurface.phone.history-outgoing', defaultMessage: 'Outgoing'},
    historyMissed: {id: 'callSurface.phone.history-missed', defaultMessage: 'Missed'},
});
